import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import CloseIcon from '@mui/icons-material/Close';

import { selectUsersForNamesById } from '../../../../store/userSelectors';
import { loadUsersMinimalDetails } from '../../../../store/userService';
import { uuid } from '../../../../utils/stringUtils';

import StatusHistory from './StatusHistory';

import app from '../../../../app.module.css';
import dropdown from '../../../../commonStyles/rowExpand.module.css';

const ClaimsForecastingRowDetails = ({ row, onClose }) => {
    // HOOKS
    const dispatch = useDispatch();

    // LOCAL STATE
    const [currentAndHistoryStatus, setCurrentAndHistoryStatus] = useState([]);
    const [missingIds, setMissingIds] = useState([]);

    // STORE STATE
    const users = useSelector(selectUsersForNamesById);

    // USE EFFECTS
    useEffect(() => {
        missingIds.length > 0 && setMissingIds([]);
    }, []);

    useEffect(() => {
        let userIds = [
            ...new Set(
                [...[...row.history].map((el) => el.userId), row.userId]
                    .filter((el) => el?.toLowerCase() !== 'polaris system')
                    .filter((el) => el)
            )
        ];
        const missingIds = userIds.filter((el) => !(el in users));
        setMissingIds(missingIds);
        missingIds.length ? dispatch(loadUsersMinimalDetails(missingIds)) : configData();
    }, [row]);

    useEffect(() => {
        if (missingIds.length < 1) return;
        if (Object.keys(users).length > 0) configData();
    }, [users]);

    // HELPER FNS
    const configData = () => {
        const updatedCurrentAndHistoryStatus = row.history.map((el) => ({
            ...el,
            emailAddress: users[el.userId]?.loginEmailAddress || 'Polaris System'
        }));
        setCurrentAndHistoryStatus([
            {
                statusId: row.claimQueueStatusId,
                reasonId: row.claimQueueReasonId,
                date: row.claimQueueDate,
                notes: row.claimQueueNotes,
                userId: row.claimQueueUserId,
                emailAddress: users[row.claimQueueUserId]?.loginEmailAddress || 'Polaris System'
            },
            ...updatedCurrentAndHistoryStatus
        ]);
    };

    // RENDER
    return (
        <div className={`${dropdown.rowDropdown} ${dropdown.redBorder}`}>
            <div className={app.sectionHeading}>Status History</div>
            {currentAndHistoryStatus.map((el) => (
                <StatusHistory key={uuid()} history={el} />
            ))}

            <div className={dropdown.exit} onClick={onClose}>
                Close details
                <CloseIcon />
            </div>
        </div>
    );
};

ClaimsForecastingRowDetails.propTypes = {
    row: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
};

export default ClaimsForecastingRowDetails;
